export default {
    transclude: true,
    template: require('./left.sub.bar.html')
}
